(function() {
    const TARGET_CONTENT = 'REFUND TO ORIGINAL PAYMENT METHOD';
    const MESSAGE_TEXT = "*PLEASE NOTE THAT THIS IS NOT THE FINAL REFUND AMOUNT. THE TOTAL REFUND WILL BE CALCULATED. THE FINAL AMOUNT MAY BE ADJUSTED FOR DEDUCTIONS SUCH AS SHIPPING, TAXES, AND FEES.";
    const MARKER_ATTR = 'data-refund-summary-message';
    const REFUND_TOTAL_TEXT = 'TO BE CALCULATED';
  
    function getReturnsRoot() {
      // Try shadow DOM first (current AfterShip rendering)
      const main = document.getElementById('MainContent');
      if (main?.shadowRoot) return main.shadowRoot;
  
      // Fallback: try other possible shadow DOM hosts
      const returnsApp = document.querySelector('.returns-app');
      if (returnsApp?.shadowRoot) return returnsApp.shadowRoot;
  
      // Fallback to light DOM (previous behavior)
      if (document.querySelector('.returns-app')) return document;
  
      return null;
    }
  
    function queryAll(root, selector) {
      return root ? [...root.querySelectorAll(selector)] : [];
    }

    function uppercaseAllTexts(root) {
      const traversalRoot = root === document ? (document.body || document.documentElement) : root;
      if (!traversalRoot) return;

      const walker = document.createTreeWalker(
        traversalRoot,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            const parentTag = node.parentElement?.tagName;
            if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
            if (parentTag && ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parentTag)) {
              return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      let node = walker.nextNode();
      let updated = 0;
      while (node) {
        const upper = node.nodeValue.toUpperCase();
        if (upper !== node.nodeValue) {
          node.nodeValue = upper;
          updated += 1;
        }
        node = walker.nextNode();
      }

      if (updated > 0) {
        console.log('[aftership-disclaimer] uppercaseAllTexts updated nodes:', updated);
      }
    }
  
    function addMessage(root) {
      if (root.querySelector(`[${MARKER_ATTR}]`)) return;
  
      const targetSpan = queryAll(root, 'span')
        .find(el => el.textContent.trim().toUpperCase() === TARGET_CONTENT);
      if (!targetSpan) return;
  
      // Verify it's inside the Summary section
      let inSummary = false;
      let parent = targetSpan.parentElement;
      while (parent) {
        if (parent.textContent.toUpperCase().includes('SUMMARY')) {
          inSummary = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!inSummary) return;
  
      const insertAfter = targetSpan.closest('div');
      if (!insertAfter?.parentNode) return;
  
      const msg = document.createElement('span');
      msg.setAttribute(MARKER_ATTR, 'true');
      msg.style.cssText = 'font-size: 13px; display: block; margin-top: 8px; color: var(--pwdd4iw, #666);';
      msg.textContent = MESSAGE_TEXT;
      insertAfter.parentNode.insertBefore(msg, insertAfter.nextSibling);
    }
  
    /** Label for the total refund row (match any casing). */
    const TOTAL_REFUND_LABEL = 'TOTAL REFUND';

    /**
     * Detects money-like text: Unicode currency symbols (\\p{Sc}) or common ISO 4217 codes.
     * @param {string} text
     * @returns {boolean}
     */
    function looksLikeCurrencyAmount(text) {
      const t = text.trim();
      if (!t) return false;
      if (/[\p{Sc}]/u.test(t)) return true;
      return /\b(?:EUR|USD|GBP|JPY|CHF|CAD|AUD|CNY|INR|SEK|NOK|DKK|PLN|HKD|SGD|NZD|MXN|BRL|TRY|ZAR|AED|KRW)\b/i.test(
        t
      );
    }

    function replaceRefundAmounts(root) {
      queryAll(root, 'span').forEach(el => {
        if (el.textContent.trim().toUpperCase() !== TOTAL_REFUND_LABEL) return;
        const sibling = el.nextElementSibling;
        const siblingText = sibling?.textContent ?? '';
        if (sibling && looksLikeCurrencyAmount(siblingText)) {
          sibling.textContent = REFUND_TOTAL_TEXT;
        }
      });
    }
  
    function run() {
      const root = getReturnsRoot();
      if (!root) return;
      addMessage(root);
      replaceRefundAmounts(root);
      uppercaseAllTexts(root);
    }
  
    // Track observed roots to avoid duplicate observers
    let observedShadow = null;
    let observedDoc = false;
  
    function setupShadowObserver(shadowRoot) {
      if (observedShadow === shadowRoot) return;
      observedShadow = shadowRoot;
      const observer = new MutationObserver(run);
      observer.observe(shadowRoot, { childList: true, subtree: true });
    }
  
    function setupDocObserver() {
      if (observedDoc) return;
      observedDoc = true;
  
      const observer = new MutationObserver(() => {
        const root = getReturnsRoot();
        if (!root) return;
  
        run();
  
        // If shadow root, observe it too
        if (root !== document) {
          setupShadowObserver(root);
        }
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
    }
  
    // Initial run
    run();
  
    // Setup observers
    setupDocObserver();
    const root = getReturnsRoot();
    if (root && root !== document) {
      setupShadowObserver(root);
    }
  
    // Fallback polling
    const interval = setInterval(() => {
      const root = getReturnsRoot();
      if (root?.querySelector(`[${MARKER_ATTR}]`)) {
        clearInterval(interval);
        return;
      }
      run();
    }, 500);
  
    setTimeout(() => clearInterval(interval), 30000);
  })();